import { ethers } from "ethers";

$(document).ready(function(){
	window.ethers = ethers;
	setProvider();

	if (window.ethers && window.ethers.providers.Web3Provider) {
		checkNetwork();
	}

	function setProvider() {
		window.provider = new ethers.providers.Web3Provider(window.ethereum);
	}

	async function checkNetwork() {
		if (window.ethers && window.ethers.providers.Web3Provider) {
			const network = await provider.getNetwork();
			console.log("network name  " + network["name"])
			if (network['chainId'] === 97) {
				$(".loading-gif-network").hide();
			} else {
				$(".loading-gif-network").show();
			}
		}
	}

	$("#imageUpload").change(function() {
		readURL(this, '#imagePreview');
		$('#user_profile_deleted').val(true);
	});


	$("#bannerUpload").change(function() {
		readURL(this, '#bannerPreview','');
		$('#user_banner_deleted').val(true);
	});

	$('#close-banner-preview-btn').click(function(){
		var imagePreview = $('#bannerPreview');
		var closePreviewBtn = $('#close-banner-preview-btn');
		var fileId = $('#bannerUpload');
		closeBannerPreview(imagePreview, closePreviewBtn, fileId);
	});

	$('#close-profile-preview-btn').click(function(){
		var imagePreview = $('#imagePreview');
		var closePreviewBtn = $('#close-profile-preview-btn');
		var fileId = $('#imageUpload');
		closeProfilePreview(imagePreview, closePreviewBtn, fileId);
	});

	function readURL(input) {
		if (input.files && input.files[0]) {
			var reader = new FileReader();
			reader.onload = function(e) {
				$('bannerPreview').css('background-image', 'url('+e.target.result +')');
				$('bannerPreview').hide();
				$('bannerPreview').fadeIn(650);
			}
			reader.readAsDataURL(input.files[0]);
		}
	}

	function readURLSingle(input) {
	    if (input.files && input.files[0]) {
	        var reader = new FileReader();
	        reader.onload = function(e) {
	            $('#my-preview-section').css('background-image', 'url('+e.target.result +')');
	            $('#my-preview-section').hide();
	            $('#my-preview-section').fadeIn(650);

	            $('#imagePreviewRes').css({ 
	            	'width': '100px', 
	            	'height': '100px', 
	            	'background-size': 'cover',
				    'background-repeat': 'no-repeat',
				    'background-position': 'center',
				    'margin-left': 'auto',
				    'margin-right': 'auto',
	            });
	            $('#close-preview-button').css('display', 'inline-block');
	            $('#imagePreviewRes').css('background-image', 'url('+e.target.result +')');
	            $('#placeholder').fadeOut(100);
	            $('#file-1').fadeOut(100);
	            $('#choose_file_selected').fadeOut(100);
	            $('#imagePreviewRes').hide();
	            $('#imagePreviewRes').fadeIn(650);
	        }
	        reader.readAsDataURL(input.files[0]);
	    }
	}
	
	$("#file-1").change(function() {
	    readURLSingle(this);
	});

	$('#close-preview-button').click(function(){
		$('#file-1').val();
		$('#placeholder').fadeIn(100);
        $('#file-1').fadeIn(100);
        $('#choose_file_selected').fadeIn(100);
        $('#choose_file_selected').html('Choose file');
        $('#imagePreviewRes').css({ 
        	'width': 'auto', 
        	'height': 'auto', 
        	'background-size': 'cover',
		    'background-repeat': 'no-repeat',
		    'background-position': 'center',
		    'margin-left': 'auto',
		    'margin-right': 'auto',
        });
        $('#close-preview-button').css('display', 'none');
        $('#imagePreviewRes').css('background-image', 'none');
        $('#my-preview-section').css('background-image', 'none');
	});


	function closeBannerPreview(imagePreview, closePreviewBtn, fileId) {
		fileId.val('');
		closePreviewBtn.css('display', 'none');
		imagePreview.css('background-image', 'url(/assets/dummybanner_bg.png)');
		$('#user_banner_deleted').val(true);
	}

	function closeProfilePreview(imagePreview, closePreviewBtn, fileId) {
		fileId.val('');
		closePreviewBtn.css('display', 'none');
		imagePreview.css('background-image', 'url(/assets/default_user.png)');
		$('#user_profile_deleted').val(true);
	}

	
});